import di from '@jsmodules/di';
import { kvManager } from '@jsmodules/storage';
import { RxDbKeyValueStorage } from '@jsmodules/storage/dist/rxdb/KeyValueStorage';

export function setupKvStorage() {
    kvManager.Creater = (input) => {
        return di.getInstance(RxDbKeyValueStorage, [input.storeName, input.encrypted, input.dbName], "Request");
    };
}
